"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var DisabledCamera = _styledComponents["default"].figure(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: #5c617c;\n  height: 100%;\n  text-align: center;\n  padding-top: 22%;\n  color: #fff;\n"])));
var AttendeeDisabledCamera = function AttendeeDisabledCamera() {
  return /*#__PURE__*/_react["default"].createElement(DisabledCamera, null);
};
var _default = exports["default"] = AttendeeDisabledCamera;